import React from 'react';
import { HighlighterElement } from './styles';
export default function Highlighter(_a) {
    var searchWords = _a.searchWords, textToHighlight = _a.textToHighlight, testId = _a.testId;
    return (React.createElement(HighlighterElement, { autoEscape: true, "data-testid": testId, searchWords: searchWords, textToHighlight: textToHighlight }));
}
